import type { ApiReservationId } from 'src/core/models/api/ApiReservation';
import type ApiCreateOneTimePasswordResponse from 'src/core/models/api/responses/ApiCreateOneTimePasswordResponse';
import ApiService from 'src/data/services/ApiService';

const ThermenRepository = {
	checkEmail: (email: string) => ApiService.auth.checkEmail(email),
	registerAccount: (data: Record<string, unknown>) => ApiService.auth.registerAccount(data),
	login: (email: string, password: string, deviceName: string) => ApiService.auth.login(email, password, deviceName),
	logout: (accessToken: string) => ApiService.auth.logout(accessToken),
	getMe: (accessToken?: string) => ApiService.auth.me(accessToken),
	requestMagicLink: (email: string) => ApiService.auth.magicLink(email),
	verifyMagicLink: (token: string) => ApiService.auth.verifyMagicLink(token),
	resendEmailVerification: (email: string) => ApiService.auth.resendVerificitation(email),
	forgotPassword: (email: string) => ApiService.auth.forgotPassword(email),
	deleteAccount: (accessToken: string, password: string) => ApiService.auth.delete(accessToken, password),
	createOneTimePassword: (type: ApiCreateOneTimePasswordResponse['type']) => ApiService.auth.createOneTimePassword(type),

	getSettings: () => ApiService.settings.get(),

	getBathCards: () => ApiService.bathcards.get(),
	addBathCard: (workspaceId: string, barcode: string) => ApiService.bathcards.add(workspaceId, barcode),
	deleteBathCard: (cardId: string) => ApiService.bathcards.delete(cardId),

	getLoyalty: () => ApiService.loyalty.get(),

	getInspiration: () => ApiService.inspiration.get(),
	getTutorial: () => ApiService.tutorial.get(),
	getWelcome: () => ApiService.welcome.get(),

	getMessages: () => ApiService.messages.get(),
	findMessage: (messageId: string) => ApiService.messages.find(messageId),
	readMessage: (messageId: string) => ApiService.messages.read(messageId),
	sendMessage: (message: string, subject: string, workspaceId: string, reservationNumber: string | null) =>
		ApiService.messages.send(message, subject, workspaceId, reservationNumber),

	getPreferences: () => ApiService.preferences.get(),
	setPreferredLanguage: (id: string) => ApiService.preferences.setPreferredLanguage(id),
	setEmailNotificationPreference: (id: string, selected: boolean) =>
		ApiService.preferences.setEmailNotificationPreference(id, selected),
	setAppNotificationPreference: (id: string, selected: boolean) =>
		ApiService.preferences.setAppNotificationPreference(id, selected),

	getProfile: () => ApiService.profile.get(),
	setAddress: (data: Record<string, unknown>) => ApiService.profile.setAddress(data),
	setPersonalData: (data: Record<string, unknown>) => ApiService.profile.setPersonalData(data),

	findReservation: <DataT>(id: ApiReservationId) => ApiService.reservations.find<DataT>(id),
	getUpcomingReservations: () => ApiService.reservations.getUpcoming(),
	getHistoricalReservations: () => ApiService.reservations.getHistorical(),
	replyToReservation: (reservationId: ApiReservationId, replyMessage: string) =>
		ApiService.reservations.reply(reservationId, replyMessage),
	addReservationManually: (workspaceId: string, reservationNumber: string) =>
		ApiService.reservations.addManually(workspaceId, reservationNumber),

	getWorkspaces: () => ApiService.workspaces.get(),
	getWorkspaceDetail: (workspaceId: number) => ApiService.workspaces.detail(workspaceId),
};

export default ThermenRepository;
